module.exports = __webpack_public_path__ + "media/images/balance-people-handshake-6126022ffd455b86fc461e3164aaabf0.png";